import { readResult } from "@/data/read-result";
import { wikiPageCount } from "@/features/preview/data";
import { readGameContext } from "./data/context";
import { readGameIndex } from "./game-index-data";

type GameRead = { data: { href: string }; signal?: AbortSignal | undefined };

export function getGameContext({ data, signal }: GameRead) {
  return readResult(() => readGameContext({ href: data.href, signal }));
}

export async function getGameWikiCount({
  data,
  signal,
}: {
  data: { coworldName: string };
  signal?: AbortSignal | undefined;
}) {
  return {
    wikiPages: await wikiPageCount({ coworldName: data.coworldName, signal }),
  };
}

export function getGameIndex({ data, signal }: GameRead) {
  return readResult(() => readGameIndex({ href: data.href, signal }));
}
